import { Controller } from 'stimulus';

// Catch http 500 responses that result in turbo:frame-missing events,
// and display them directly instead of letting turbo show its “Content Missing” placeholder.
export default class extends Controller {

  connect() {
    document.addEventListener('turbo:frame-missing', this.#handleFrameMissing.bind(this));
  }

  disconnect() {
    document.removeEventListener('turbo:frame-missing', this.#handleFrameMissing.bind(this));
  }

  // eslint-disable-next-line class-methods-use-this
  async #handleFrameMissing(event) {
    const {
      redirected,
      status,
      body
    } = event.detail.response;
    const responseHTML = await new Response(body).text();

    if (status === 500) {
      event.preventDefault();

      // We should visit the 500 page, since it does not contains any turbo-frame-id
      // do a visit with the html content response
      // see https://turbo.hotwired.dev/reference/events#turbo%3Aframe-missing
      event.detail.visit(location, {
        response: {
          redirected,
          status,
          responseHTML
        }
      });
    }

  }
}
